export const config = {
  title: "Pasadena Repair Pro | Expert Handyman Services | Los Angeles, CA",
  meta: {
    description:
      "Pasadena Repair Pro provides expert handyman and home repair services in Los Angeles and Pasadena, CA. Professional electrical, plumbing, carpentry, painting, and general repair services.",
    keywords: [
      "Pasadena Repair Pro",
      "Handyman Los Angeles",
      "Home Repair Pasadena",
      "Electrical Services CA",
      "Plumbing Repair",
      "Carpentry Services",
      "Painting Contractor",
      "General Handyman",
      "Home Maintenance"
    ],
    author: "Pasadena Repair Pro",
    canonicalUrl: "https://pasadenarepairpro.com/",
  },
  sections: {
    header: {
      businessName: "Pasadena Repair Pro",
    },
    sectionB: {
      heroTitle: "Expert Handyman Services in Los Angeles & Pasadena",
      heroSubtitle: "Professional Home Repair & Maintenance Solutions",
      learnAboutText: "Get Your Free Estimate",
      phoneNumber: "3109946415",
      phoneLabel: "(310) 994-6415",
      heroBackgroundImage:
        "https://media.istockphoto.com/id/2187421629/photo/plumber-house-and-handyman-with-clipboard-inspection-and-maintenance-with-expert-employee.jpg?s=612x612&w=0&k=20&c=rqPHAz0849mFaQ2Box2eszZDaZZ9pDbvCUKJCZ700RI=",
      cardData: [
        {
          title: "Electrical Services",
          description:
            "Professional electrical repairs, installations, and maintenance for residential and commercial properties.",
        },
        {
          title: "Plumbing Solutions",
          description:
            "Expert plumbing services including repairs, installations, and emergency fixes for all your water needs.",
        },
        {
          title: "General Repairs",
          description:
            "Comprehensive handyman services covering carpentry, painting, drywall, and all general home repairs.",
        },
      ],
      description:
        "Pasadena Repair Pro is your trusted partner for professional handyman and home repair services in Los Angeles and Pasadena. We provide reliable, quality workmanship for all your home maintenance needs.",
    },
    sectionC: {
      servicesTitle: "Comprehensive Handyman Services",
      servicesDescription:
        "Professional, reliable, and affordable handyman services for all your home repair and improvement needs in Los Angeles and Pasadena areas.",
      cards: [
        {
          title: "Electrical Services",
          description:
            "Complete electrical solutions including outlet installation, lighting fixtures, switch repairs, ceiling fans, and electrical troubleshooting.",
          imageSrc: "https://media.istockphoto.com/id/2166685594/photo/electricity-and-electrical-maintenance-service-electrical-tests-industrial-electrical.jpg?s=612x612&w=0&k=20&c=SNQCi1fO5KNMCJLaQIbEW6hQNJQ1XBGGpytgeT6hX0I=",
          imageAlt: "Electrical Services",
        },
        {
          title: "Plumbing Services",
          description:
            "Professional plumbing services covering faucet repairs, toilet installation, pipe fixes, drain cleaning, and water heater maintenance.",
          imageSrc: "https://media.istockphoto.com/id/2193338886/photo/plumber-hands-holding-wrench-doing-repairing-work-at-the-sink-and-clogged-pipe-in-bathroom.jpg?s=612x612&w=0&k=20&c=fLJUTEfr46c3T4NdAHWrYON8VkQ1SmW2utFyoERwYUk=",
          imageAlt: "Plumbing Services",
        },
        {
          title: "Carpentry & Repairs",
          description:
            "Expert carpentry work including door installation, trim work, cabinet repairs, furniture assembly, and custom woodwork.",
          imageSrc: "https://media.istockphoto.com/id/481628382/photo/carpenter-taking-measurement.jpg?s=612x612&w=0&k=20&c=l2cAPfJL2bGltBasmnqUlsz2OHv6H6bUzjzhx0feOJg=",
          imageAlt: "Carpentry Services",
        },
      ],
      otherServicesTitle: "Additional Services",
      otherServicesList: [
        "Painting & Drywall Repair",
        "Appliance Installation",
        "Furniture Assembly",
        "Tile & Flooring Work",
        "Home Maintenance",
      ],
    },
    sectionD: {
      aboutTitle: "About Pasadena Repair Pro",
      aboutImage: {
        src: "https://cdn.builder.io/api/v1/image/assets%2Fb90c050106304b44ba46f6701b0ee39f%2Ff35102c97b2f4271afa2e616d99f54af?format=webp&width=800",
        alt: "Pasadena Repair Pro Team",
      },
      aboutText: [
        "Pasadena Repair Pro is a trusted handyman service company serving Los Angeles and Pasadena areas. We specialize in providing reliable, professional, and affordable home repair and maintenance solutions for residential and commercial properties.",
        "Our experienced team of skilled professionals is committed to delivering quality workmanship and exceptional customer service. Whether you need electrical work, plumbing repairs, carpentry services, or general maintenance, we have the expertise to handle projects of any size with precision and care.",
      ],
    },
    sectionE: {
      profileImage: "https://cdn.builder.io/api/v1/image/assets%2Fb90c050106304b44ba46f6701b0ee39f%2Ff35102c97b2f4271afa2e616d99f54af?format=webp&width=800",
      profileAlt: "Pasadena Repair Pro",
      businessName: "Pasadena Repair Pro",
      contact: {
        phone: "3109946415",
        phoneLabel: "(310) 994-6415",
        email: "info@etherionhome.com",
        website: "https://pasadenarepairpro.com/",
        address: "1211 North Alexandria Ave, Los Angeles, CA 90029",
      },
      socialMedia: {
        facebook: "https://www.facebook.com/PasadenaRepairPro",
        instagram: "https://www.instagram.com/pasadenarepairpro",
      },
    },
    sectionF: {
      address: "1211 North Alexandria Ave, Los Angeles, CA 90029",
      googleMapsEmbedUrl:
        "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3304.5123456789!2d-118.2904567!3d34.0954567!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88c2c8f1234567890a%3A0x1234567890abcdef!2s1211%20N%20Alexandria%20Ave%2C%20Los%20Angeles%2C%20CA%2090029!5e0!3m2!1sen!2sus!4v1698765432100!5m2!1sen!2sus",
    },
  },
};

export default config;